"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _dist = require("react-day-picker/dist");
var _DayModule = _interopRequireDefault(require("./Day.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Day = _ref => {
  let {
    displayMonth,
    date
  } = _ref;
  const ref = (0, _react.useRef)(null);
  const {
    buttonProps,
    modifiers: {
      today,
      selected
    }
  } = (0, _dist.useDay)(date, displayMonth, ref);
  const {
    classNameDay,
    testAttrDay
  } = (0, _dist.useDayPicker)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    "data-test": testAttrDay
  }, buttonProps), {}, {
    className: (0, _cnbuilder.cnb)(_DayModule.default.root, {
      [_DayModule.default.today]: today
    }, {
      [_DayModule.default.selected]: selected
    }, classNameDay),
    "data-cal-selected": selected,
    "data-cal-today": today,
    "data-cal-day": true
  }));
};
var _default = exports.default = Day;